<fieldset class=panel data-help="state">
	<!-- master situation box -->
	{#if user.isMaster}
		<h3>Direkte Effekte</h3>
		<div class=occurrence data-help="bestow">
			<select bind:value={efftype} class="text" placeholder="Effekt" >
				{#each Object.keys(catEffects) as cat}
					<optgroup label={cat}></optgroup>
					{#each catEffects[cat] as eff}
						<option value={eff.type} title={eff.summary}>{eff.type}</option>
					{/each}
				{/each}
			</select>
			<input bind:value={params} type="text" class="text" placeholder="{protoEffects[efftype]?.params ?? 'Parameter'}">
			<input bind:value={span} type="number" min=0 max=999 placeholder="Dauer" class=text>
			<button class="button miniButton" onclick={bestow_effect}>
					<img src="/static/buttons/start.png" alt="Start" title="Effekt starten">
			</button>
		</div>
		<p>{protoEffects[efftype]?.descript}</p>
	{/if}

	<div>
		<h3>Situation:</h3>
		<div class="gridded" data-help="conditions">
			<datalist id="tickmarks">
				<option value="0"></option>
			</datalist>
			{#each allConditions as condition}
				<input type=checkbox checked={condition.checked} onchange={toggle_condition.bind(condition)}/>
				<p>{condition.label}</p>
				<input type=range value={-condition.diffclt} min={condition.min} max={condition.max}
				 disabled={!condition.checked} list=tickmarks onchange={adjust_condition.bind(condition)}>
				<output title="{condition.ZUB} + {condition.hiding} - {condition.diffclt}">{condition.total}</output>
			{/each}
			<!-- remove fighter -->
			<div class="triplespan buttonBar" data-help="visibility">
					<button class=button onclick={toggle_state}>{toggleState} machen</button>
					<button class=button onclick={remove_fighter}>Kämpfer entfernen</button>
			</div>
		</div>
	</div>

	{#if view.character.ZUB !== 'Hero'}
		<div id="affilSelect">
			<h3>Zugehörigkeit</h3>
			<Select field=affil value={view.persona.affil} options={affiliations} unlabeled onchange={change_affil} />
		</div>
	{/if}

    {#if view.map}
	  <div>
          <h3>Position</h3>
          <div class=position data-help="position" onchange={change_position}>
              <p>Position</p>
              <Input field=col value={view.persona.position.col} type=number />
              <Input field=row value={view.persona.position.row} type=number />
              <Input field=layer value={view.persona.position.map} type=text />
              <button class="button miniButton" onclick={transfer_fighter}>
                <img src="/static/buttons/crossmark.png" alt="Fokus">
              </button>
          </div>
      </div>
    {/if}
</fieldset>


<script>
		import { user, game, view, send_request} from "../client.svelte.js";
		import {protoEffects, Location, noPosition} from "../core.js";
		import Input from "../elements/Input.svelte";
		import Select from "../elements/Select.svelte";

    let catEffects = Object.groupBy(Object.entries(protoEffects)
        .map(([type,data]) => Object.assign({type: type}, data))
        , eff => eff.ZUB)

		const condDefaults = {
			Hidden: {condID: 'Hidden', label: "verborgen", min: -25, max: +10},
			Watchful: {condID: 'Watchful', label: "wachsam", min: -25, max: +10},
			Swimming: {condID: 'Swimming', label: "schwimm.", min: -35, max: 0},
			Climbing: {condID: 'Climbing', label: "kletternd", min: -35, max: 0},
			Downed: {condID: 'Downed', label: "niederg.", min: -20, max: 0},
			Held: {condID: 'Held', label: "festgeh.", min: -20, max: 0}
		}

		let conditions = $derived(
			Object.fromEntries(
				view.persona.affects
					.filter(effID => effID.split(" ")[0] in condDefaults)
					.map(effID => Object.assign({checked: true}, game.effects.get(effID), condDefaults[effID.split(" ")[0]]) )
					.map(cond => [cond.condID, cond]) ) )
		// $inspect(`STATE - conditions`, conditions)

		let allConditions = $derived(
			Object.values(condDefaults)
				.map(cond => Object.assign({}, cond, conditions[cond.condID])) )
		// $inspect(`STATE - allConditions`, allConditions)

	  let efftype = $state(""), params = $state(""), span = $state(null)
    let toggleState = $derived((view.persona.isVisible || view.persona.affects?.['Hidden']?.diffclt === -99) ? 'unsichtbar' : 'sichtbar')

		const affiliations = ['neutral', 'enemy', 'friend']
    let newPosition = {}


		/** Master bestows an effect onto a player  **/
    function bestow_effect() {
        let data = {}
        if (span === 'inf')  span = 9999
        if (efftype.includes("W100") || efftype.includes("W6")) {
            data = {action: "Zufall", risk: (efftype === "W100") ? 1 : Number(efftype.charAt(0)),
                    descript: `Der Zufall entscheidet für ${view.persona.ID}`}
        } else {
            data = {instruct: 'INCUR', subject: view.persona.ID, coding: efftype, params: params, span: span}
        }
        send_request('instruct', data)
        efftype = params = ""
        span = null
		}


		/*** Condition switching ***/

    function toggle_condition(event) {
        if (event.target.checked)
            send_request('instruct', {instruct: 'INCUR', subject: view.persona.ID, coding: this.condID})
        else
            send_request('instruct', {instruct: 'REMOVE', subject: view.persona.ID, target: this.condID})
		}

    function adjust_condition(e) {
        const diffclt = - Number(e.target.value)
        console.log(`STATE: Change difficulty of condition ${this.name} to ${diffclt}`, this)
        send_request('adjust', {persona: view.persona.ID, effect: this.ID, diffclt: diffclt})
		}

    function toggle_state(e) {
        console.log(`STATE: Toggle state of fighter ${view.persona.ID} to ${toggleState}`)
        if (toggleState === 'unsichtbar') {
            send_request('instruct', {instruct: 'INCUR', coding: 'Invisible', target: view.persona.ID, text: `${view.persona.ID} ist nicht mehr sichtbar.`})
            // state = 'inaktiv'
        } else {
            send_request('instruct', {instruct: 'REMOVE', subject: view.persona.ID, target: 'Invisible', text: `${view.persona.ID} greift ins Spiel ein.`})
            // state = 'aktiv'
        }
		}

    function remove_fighter() {
        send_request('instruct', {instruct: 'COLLAPSE', subject: view.persona.ID, text: `${view.persona.ID} bricht zusammen.`})
		}

		function change_affil(e) {
				const newaffil = e.target.value
				if (!newaffil)  return
        console.log(`STATE: Change affil of ${view.persona.ID} to ${newaffil}`)
        send_request('adjust', {persona: view.persona.ID, attrib: 'affil', value: newaffil})
		}

    function change_position(e) {
        const attr = e.target.id
        newPosition[attr] = (attr === 'col' || attr === 'row') ? Number(e.target.value) : e.target.value
    }

    function transfer_fighter() {
        let aim = new Location(newPosition)
        console.log(`STATE: Transfer entity ${view.persona.ID} to ${aim.toStr()}`)
        send_request('instruct', {instruct: 'TRANSFER', subject: view.persona.ID, target: aim.toStr()})
        newPosition = {}
		}
</script>

<style lang="sass">
	.panel
		display: block
		border: none
		margin: 0
		padding: 0

	.panel input, .panel select
		background-color: black

	.gridded
		display: grid
		grid-template-columns: 3ch 8ch auto 3ch
		grid-gap: 5px
		margin: 5px
		/*font-size: 1.2em*/

	.position
		display: grid
		grid-template-columns: 8ch 6ch 6ch 8ch 3ch
		grid-gap: 5px
		margin: 5px
		/*font-size: 1.2em*/

	.occurrence
		display: grid
		grid-template-columns: 2fr 2fr 1fr 44px
		grid-gap: 8px
		width: 386px
		margin: 6px

	.buttonBar
		display: flex
		justify-content: space-around

	button
		background-color: darkgrey

	button img
		width: 100%
</style>